import React, { useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

/* 弹窗最大化：返回 max 状态 + 用于 DialogContent / iframe 的 class + 右上角切换按钮（放在关闭 X 左侧）。

   2026-10-13 修复「放大后底部按钮点不到 / 放大没真正铺满」：
   ① 宽度没生效：`max-w-[100vw] w-[100vw]` 与调用方传的 `max-w-4xl / max-w-5xl` 同属 max-width/width 工具类，
      谁在编译后的 CSS 里靠后就谁赢 —— 实测 `max-w-4xl` 赢了，放大后卡片宽度纹丝不动（仍 ~958px）。
      改用 `!` 重要修饰符（`!max-w-none !w-screen !h-[100dvh] !max-h-[100dvh]`）强制覆盖。
      同理 DialogContent 基础类里有 `grid`，要让 `flex flex-col` 生效也必须写 `!flex`（display 工具类同理有先后）。
   ② 底部「关闭 / 下载 / 打印」被挤出卡片下沿：原先 iframe 高度写死 `calc(100dvh - 固定 offset)`，
      而 offset 是猜的（header 文案换行、root font-size=18px 都会让实际占位变化）→ 实测内容比可视区高 72px，
      操作行落到卡片外面（y 超出卡片底边）自然点不到。
      改为 max 态下内容区 `!flex flex-col`，iframe 用 `flex: 1 1 0% + min-height: 0`（frameStyle 内联给出）
      自动吃掉剩余高度 —— 不论 header 多高，操作行都恒在可视区内。
   ③ 保留非 max 态的原有行为（返回 undefined / 调用方 base class），不影响其它弹窗。 */
export function useMaximize() {
  const [max, setMax] = useState(false);
  return {
    max,
    toggle: () => setMax((v) => !v),
    contentCls: (base) => (max
      ? "!max-w-none !w-screen !h-[100dvh] !max-h-[100dvh] rounded-none !flex flex-col overflow-y-auto"
      : base),
    // max 态：交给 flex 布局自适应（inline style 优先级高于 class，可压过调用方的 h-[420px] lg:h-[560px]）
    frameStyle: () => (max ? { flex: "1 1 0%", minHeight: 0, height: "auto" } : undefined),
  };
}

export function MaxButton({ max, onToggle, zh, testId = "dialog-max" }) {
  return (
    <button type="button" onClick={onToggle} data-testid={testId} data-max={max ? 1 : 0}
      title={max ? (zh ? "还原" : "Restore") : (zh ? "最大化 / 全屏" : "Maximize")}
      className="absolute right-11 top-3.5 rounded-sm p-1 text-slate-500 opacity-70 hover:opacity-100 hover:text-brand-600 transition-opacity">
      {max ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
    </button>
  );
}
